module.exports = __webpack_public_path__ + "img/eye_open.0f6ce760.png";